import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {LocalStorageService} from 'src/app/modules/local-storage/local-storage.module';
import {ShoppingService} from '../../component/services/shopping.service';
import {FilterService} from '../../component/services/filter.service';
import {tap} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable()
export class AuthService {

  private _user: any;
  public get user(): any {
    return this._user;
  }

  constructor(private localStorageService: LocalStorageService, private http: HttpClient,
              private shopService: ShoppingService, private filterService: FilterService) {}

  public me() {
    return this.http.get(`${environment.auth_api}users/me?company=true`,
      {headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})});
  }

  public  loadUser(): Promise<any> {
    return new Promise(resolve => {
      if (this.isAuthenticated()) {
        this.me().subscribe(data => {
          if (data['success']) {
            this._user = data['data'];
            this.shopService.Load();
            this.filterService.load();
          }
          resolve(undefined);
        }, () => {
          if (this.hadRefresh()) {
            this.refreshAccessToken().subscribe(() => {
              this.me().subscribe(data => {
                if (data['success']) {
                  this._user = data['data'];
                  this.shopService.Load();
                  this.filterService.load();
                }
                resolve(undefined);
              }, () => resolve(undefined) );
            }, () => resolve(undefined));
          } else {
            resolve(undefined);
          }
        });
      } else {
        resolve(undefined);
      }
    });
  }

  private refreshAccessToken(): Observable<any> {
    const token: string = this.localStorageService.get('refresh-token');
    const result = token.split(' ');

    const data = {
      grant_type: 'refresh_token',
      refresh_token: result[1],
      redirect_uri: environment.redirectUri
    };
    return this.http.post(`${environment.auth_api}auth/token`, data).pipe(
      tap((response: {token_type: string, access_token: string, refresh_token: string}) => {
        if (response.hasOwnProperty('access_token') && response.hasOwnProperty('refresh_token')) {
          this.localStorageService.set('access-token', `${response.token_type} ${response.access_token}`);
          this.localStorageService.set('refresh-token', `${response.token_type} ${response.refresh_token}`);
        }
      }));

  }

  public isAuthenticated(): boolean {
    return this.localStorageService.keys().indexOf('access-token') !== -1;
  }

  public hadRefresh(): boolean {
    return this.localStorageService.keys().indexOf('refresh-token') !== -1;
  }
}
